var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "channel-thumbnail" }, [
    _vm.thumbnailUrl
      ? _c("img", {
          staticClass: "image",
          attrs: { src: _vm.thumbnailUrl, alt: "", loading: "lazy" },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }